// Generated by tutorials/record.cjs from tutorials/articles/h45-holiday-and-one-time-menus.cjs.
// Do not edit: change the script and run `node tutorials/record.cjs h45 --text-only` (wording) or
// `node tutorials/record.cjs h45` (pictures and clips).
import type { HelpArticle } from '../types';

const article: HelpArticle = {
  slug: 'holiday-and-one-time-menus',
  catalogId: 'h45',
  title: 'Holiday and one-time menus',
  summary: 'A holiday or one-time menu takes the place of the cycle\'s meal on one date, such as Thanksgiving dinner. Add one, change its items, and see it on its date.',
  audience: 'Menu planners and dietary managers who plan special meals',
  area: 'menus',
  learn: [
    'What a holiday or one-time menu is',
    'Add one for a date and a meal',
    'Change its items without changing the cycle',
    'Open another holiday menu from the menu editor',
    'See which holiday menu the cycle serves on a date',
    'Copy holiday menus to another cycle',
  ],
  keywords: [
    'holiday',
    'holiday menu',
    'one time menu',
    'one-time',
    'special meal',
    'thanksgiving',
    'christmas',
    'override menu',
    'event',
    'recurring',
    'replace a meal',
    'date',
    'party',
    'cookout',
    'copy holiday',
    'another cycle',
    'copy to another menu cycle',
  ],
  steps: [
    {
      id: 'list',
      part: 'Add a one-time menu',
      heading: 'Open the cycle\'s holiday menus',
      text: 'A holiday or one-time menu takes the place of the cycle\'s meal on one date: Thanksgiving dinner, a picnic, a special lunch.\n\nOn the Menu Cycles page, select the cycle, then More actions (the three dots) and Holiday / Override Menus. Each row is one menu, with its date and meal.',
      media: {
        image: {
          src: '/help/holiday-and-one-time-menus/list.webp',
          width: 1280,
          height: 842,
        },
        clip: {
          src: '/help/holiday-and-one-time-menus/list.mp4',
          width: 1280,
          height: 842,
          durationSec: 5.3,
        },
        alt: 'The Holiday/Override Menus window for Fall/Winter Cycle 2026, listing Thanksgiving Dinner, Christmas Day, Christmas Eve Supper and the others with their mealtimes and dates.',
      },
    },
    {
      id: 'new',
      part: 'Add a one-time menu',
      heading: 'Select New',
      text: 'Select New. Type stays Standard and Frequency One Time for a menu served once.',
      media: {
        image: {
          src: '/help/holiday-and-one-time-menus/new.webp',
          width: 1280,
          height: 824,
        },
        clip: {
          src: '/help/holiday-and-one-time-menus/new.mp4',
          width: 1280,
          height: 824,
          durationSec: 3.4,
        },
        alt: 'The new holiday menu window with Type Standard, Frequency One Time, Date, Mealtime, Menu Name, Menu Day, End Date and Note.',
      },
    },
    {
      id: 'details',
      part: 'Add a one-time menu',
      heading: 'Pick the date and the meal, and name it',
      text: 'Type the Date and pick the Mealtime the menu replaces. Menu Day shows where that date falls in the cycle.\n\nType a Menu Name the kitchen will recognize, and a Note if it helps.',
      media: {
        image: {
          src: '/help/holiday-and-one-time-menus/details.webp',
          width: 1280,
          height: 824,
        },
        clip: {
          src: '/help/holiday-and-one-time-menus/details.mp4',
          width: 1280,
          height: 824,
          durationSec: 6,
        },
        alt: 'Date 11/11, Mealtime Afternoon, Menu Name Veterans Day Lunch, Menu Day MC Day 11, and the note Lunch with the veterans group.',
      },
    },
    {
      id: 'created',
      part: 'Add a one-time menu',
      heading: 'Save it',
      text: 'Select Save and Open. The new menu starts as a copy of the cycle\'s meal on that date, so you only change what is different. It is turned on for that date at once.',
      media: {
        image: {
          src: '/help/holiday-and-one-time-menus/created.webp',
          width: 1280,
          height: 842,
        },
        clip: {
          src: '/help/holiday-and-one-time-menus/created.mp4',
          width: 1280,
          height: 842,
          durationSec: 2.4,
        },
        alt: 'The message Menu Created and Turned On: VETERANS DAY LUNCH was created with menu rows copied from Fall/Winter Cycle 2026 and turned on.',
      },
    },
    {
      id: 'opened',
      part: 'Add a one-time menu',
      heading: 'See its items',
      text: 'Select OK. The menu opens in the menu editor, with its name at the top. Pick its meal, here Afternoon, to see the items copied from the cycle.',
      media: {
        image: {
          src: '/help/holiday-and-one-time-menus/opened.webp',
          width: 1280,
          height: 842,
        },
        clip: {
          src: '/help/holiday-and-one-time-menus/opened.mp4',
          width: 1280,
          height: 842,
          durationSec: 6,
        },
        alt: 'VETERANS DAY LUNCH open in the menu editor on Afternoon, with the soup, LASAGNA and the alternate, the starch, the vegetable and COOKIE OATMEAL copied from the cycle.',
      },
    },
    {
      id: 'change',
      part: 'Change its items',
      heading: 'Change a row',
      text: 'Select Edit menu, then change rows the usual way: here the dessert is changed to PIE APPLE by selecting it, pressing Enter and picking the new item.\n\nOnly this menu changes. The cycle keeps its own dessert for that day every other time it comes round.',
      media: {
        image: {
          src: '/help/holiday-and-one-time-menus/change.webp',
          width: 1280,
          height: 842,
        },
        clip: {
          src: '/help/holiday-and-one-time-menus/change.mp4',
          width: 1280,
          height: 842,
          durationSec: 6,
        },
        alt: 'The item editor on the dessert row of VETERANS DAY LUNCH, with PIE APPLE picked.',
      },
    },
    {
      id: 'changed',
      part: 'Change its items',
      heading: 'Save the change',
      text: 'Select Save. The change is saved at once, like any change in the menu editor. The new item brings its own Auto Item Mods, so here Cardiac trays get FRUIT COCKTAIL and CCHO trays PIE APPLE SF.',
      media: {
        image: {
          src: '/help/holiday-and-one-time-menus/changed.webp',
          width: 1280,
          height: 1004,
        },
        clip: {
          src: '/help/holiday-and-one-time-menus/changed.mp4',
          width: 1280,
          height: 1004,
          durationSec: 3.8,
        },
        alt: 'VETERANS DAY LUNCH with PIE APPLE as the dessert, FRUIT COCKTAIL for Cardiac and PIE APPLE SF for CCHO.',
      },
    },
    {
      id: 'switch',
      part: 'Open another holiday menu',
      heading: 'List the cycle\'s holiday menus',
      text: 'In the menu editor, select More actions, then Holiday menus. It lists every holiday menu of the cycle with its date and meal. Select one to open it.',
      media: {
        image: {
          src: '/help/holiday-and-one-time-menus/switch.webp',
          width: 1280,
          height: 842,
        },
        clip: {
          src: '/help/holiday-and-one-time-menus/switch.mp4',
          width: 1280,
          height: 842,
          durationSec: 4.4,
        },
        alt: 'The Holiday menus of Fall/Winter Cycle 2026 list: Thanksgiving Dinner on November 26 at Afternoon, Christmas Day, VETERANS DAY LUNCH open now, and the others.',
      },
    },
    {
      id: 'thanksgiving',
      part: 'Open another holiday menu',
      heading: 'Open Thanksgiving Dinner',
      text: 'Select Thanksgiving Dinner, then its meal. Here the turkey dinner with stuffing, sweet potatoes and pumpkin pie takes the place of that day\'s lunch, with the same diet columns as the cycle: Renal trays still get RICE WHITE in place of the potatoes.',
      media: {
        image: {
          src: '/help/holiday-and-one-time-menus/thanksgiving.webp',
          width: 1280,
          height: 842,
        },
        clip: {
          src: '/help/holiday-and-one-time-menus/thanksgiving.mp4',
          width: 1280,
          height: 842,
          durationSec: 5.6,
        },
        alt: 'Thanksgiving Dinner open on Afternoon: TURKEY ROAST with GRAVY CHICKEN and STUFFING BREAD, HAM BAKED, POT MASHED, SWEET POTATO MASHED, GREEN BEANS and the rolls.',
      },
    },
    {
      id: 'on-date',
      part: 'See it on its date',
      heading: 'See the holiday on the cycle',
      text: 'Go back to the cycle (More actions, Holiday menus, Back to the cycle), select the calendar beside the day and pick the holiday\'s date. The mark beside the day says which holiday menu replaces that meal.\n\nOn that date, tray tickets, Selective Touch and production use the holiday menu for that meal. The cycle\'s own meal comes back the next time.',
      media: {
        image: {
          src: '/help/holiday-and-one-time-menus/on-date.webp',
          width: 1280,
          height: 842,
        },
        clip: {
          src: '/help/holiday-and-one-time-menus/on-date.mp4',
          width: 1280,
          height: 842,
          durationSec: 6,
        },
        alt: 'Fall/Winter Cycle 2026 on November 26, Afternoon, with the mark One Time: Thanksgiving Dinner beside the day.',
      },
    },
    {
      id: 'copy-to-cycle',
      part: 'Copy to another menu cycle',
      heading: 'Copy holiday menus to another cycle',
      text: 'When a new cycle starts late, its holiday menus can be copied to the cycle still being served. On the Menu Cycles page, open the cycle, select a holiday menu, then More actions and Copy to Another Menu Cycle (the Holiday/Override Menus window has the same button).\n\nPick the cycle to copy to and check every holiday menu to copy. Each copy keeps its name, date, meal, note and items, and is turned on. If that cycle already has a menu for the same date and meal, the window says so, and that menu is turned off when the copy is turned on.\n\nDiet settings go to the other cycle\'s diet types and consistencies. One that cycle does not have is not copied, and the window names it.',
      placeholder: {
        note: 'This screen is on its way to Dietech Online.',
        record: 'Menu Cycles, Fall/Winter Cycle 2026 expanded, Christmas Day selected, More actions, Copy to Another Menu Cycle; pick Spring/Summer Cycle 2026, also check Thanksgiving Dinner, Copy 2 Menus, then the message with Open (fixture: CopyHolidaysToCycle in fixtures/help-mc-list.cjs).',
      },
    },
  ],
  tips: [
    'Frequency Recurring makes a menu that comes back every time the cycle reaches its Menu Day, such as a fish lunch every week 1 Friday.',
    'Type Always Served makes an override for the always served items (such as the drinks offered at every meal) instead of a meal.',
    'Use the Swap menu days page (Tools in the menu editor) when a delivery did not come and two dates need to trade meals. It makes the one-time menus for you.',
    'Delete a holiday menu you no longer need from the same Holiday/Override Menus window. It goes to the Recycle Bin.',
  ],
  notes: [
    'A holiday menu replaces the cycle\'s meal only for its own meal and date. The other meals that day come from the cycle as usual.',
    'Changing a holiday menu never changes the cycle, and changing the cycle later does not change a holiday menu already made.',
    'Adding and changing holiday menus needs the right role. If New is missing, ask your administrator.',
  ],
  related: [
    'menu-cycles',
    'changing-menu-items',
    'menu-swap-and-requests',
    'tray-tickets',
    'selective-touch',
  ],
  recorded: '2026-10-26',
};

export default article;
